// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".S9ydIfkMcN1rp7x93GqJ {\n  display: grid;\n  justify-content: center;\n  justify-items: center;\n}\n", "",{"version":3,"sources":["webpack://./src/pages/editar-mascota/index.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,qBAAqB;AACvB","sourcesContent":[".container {\n  display: grid;\n  justify-content: center;\n  justify-items: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "S9ydIfkMcN1rp7x93GqJ"
};
export default ___CSS_LOADER_EXPORT___;
